<template>
  <div>
    <div class="container">
      <div class="hotel-banner">
        <div class="hotel-name">
          <h2>
            {{ hotel.name }}
            <small class="hotel-stars">
              <i
                v-for="star in stars"
                :key="star.index"
                class="ionicon star-icon fa fa-star"
              />
            </small>
          </h2>
        </div>
        <div class="start-price">
          <p>
            {{ $t('h4h.startsAt') }}
            <b class="bold-price">
              <CurrencyConvert
                :amount="price / hotel.stayDuration"
                :currency="'USD'"
              />
            </b>
            {{ $t('h4h.perNight') }}
          </p>
        </div>
      </div>
      <div
        v-if="contractedHotel && transportationProvided"
        class="contract-featured-bubble"
      >
        {{ $t('h4h.featuredWithTransportation') }}
      </div>
      <div
        v-else-if="contractedHotel"
        class="contract-featured-bubble"
      >
        {{ $t('h4h.featured') }}
      </div>
      <div class="hotel-basic-info">
        <p>{{ hotel.fullAddress }}</p>
        <p v-if="hotel.directions">
          {{ hotel.directions.distance.text }} to {{ this.$store.state.hotel.venue }}
        </p>
      </div>
    </div>
    <ImageCarousel
      :images="hotel.images"
    />
    <div class="hotel-info-amenities-container container">
      <div class="hotel-main-info">
        <h4><b>{{ $t('h4h.chooseARoom') }}</b></h4>
        <div class="checkin-info">
          <div class="stay">
            <p><b>{{ $t('h4h.checkIn') }} - {{ $t('h4h.checkOut') }}</b></p>
            {{ hotel.checkIn }} - {{ hotel.checkOut }}
          </div>
          <RoomQuantity
            v-if="hotel.contracted"
            :contracted="hotel.contracted"
          />
          <div
            v-else
            class="rooms"
          >
            <p>
              <b>{{ $t('h4h.roomNum') }}</b>
            </p>
            <p>
              {{ this.$store.state.hotel.roomQty }}
            </p>
          </div>
          <br>
          <div class="room-information">
            <RetailRoomCard
              v-for="room in hotel.rooms"
              :key="room.index"
              :check-in="hotel.checkIn"
              :check-out="hotel.checkOut"
              :room="room"
              :stay-duration="hotel.stayDuration"
            />
          </div>
          <h4 class="property-description">
            <b>{{ $t('h4h.propertyDescription') }}</b>
          </h4>
          <p>{{ hotel.description }}</p>
          <Map
            :hotel-latitude="parseFloat(hotel.latitude)"
            :hotel-longitude="parseFloat(hotel.longitude)"
            :hotel-name="hotel.name"
            :event-name="order.event_name"
            :event-latitude="order.event_latitude"
            :event-longitude="order.event_longitude"
          />
        </div>
      </div>
      <div class="hotel-side-container">
        <HotelAmenities
          :amenities="hotel.amenities"
        />
        <Rating
          :rating="hotel.rating"
          :reviews="hotel.reviews"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { CurrencyConvert } from '../../../default/currency_convert'
import ImageCarousel from './hotel_images'
import RoomQuantity from '../h4h_search_form/room_quantity'
import RetailRoomCard from './retail_room_card'
import HotelAmenities from './hotel_amenities'
import Rating from './hotel_rating'
import Map from './maps'
import { mapGetters } from 'vuex'


export default {
  components: {
    CurrencyConvert,
    ImageCarousel,
    RoomQuantity,
    RetailRoomCard,
    HotelAmenities,
    Rating,
    Map,
  },

  props: {
    order: {
      required: true,
      type:Object
    }
  },

  computed: {
    ...mapGetters('hotel', [
      'getCheckInDate',
      'getCheckOutDate',
      'getContractedCheckInDate',
      'getContractedCheckOutDate',
      'getLowestValue'
    ]),
    hotel() {
      return this.$store.state.hotel.hotel
    },
    contractedHotel(){
      return this.hotel.qng_id ? true : false
    },
    stars() {
      let stars = this.$store.state.hotel.hotel.starRating
      if(stars) stars = stars.charAt(0)
      return parseInt(stars)
    },
    price() {
      return this.getLowestValue(this.hotel.id)
    },
    transportationProvided(){
      return this.hotel.transportationFee > 0 ? true : false
    }
  }
}
</script>
